import React from 'react';
import { useEffect, useState } from "react";
import { useColors } from "../../constants/useColors";
import ProgressBar from './ProgressBar';

type ProgressTimerProps = {
    max_value: number,
    time_id:string,
    current_value:number
    increment_type?:'seconds'|'minutes'
    max_label?:string,
    update_multiplier?: number
    onTimesUp:() => void
}

const ProgressTimer = ({increment_type, current_value, max_value, time_id, max_label, onTimesUp}:ProgressTimerProps) => {
    const Colors = useColors();
    const [ started, setStarted ] = useState(false);
     const [ seconds_remaining, setSecondsRemaining ] = useState<{
        time_id?:string,
        seconds:number
     }>({
        seconds:0
     });
     const increment_time = increment_type == 'minutes' ? 60000 : 1000
    useEffect(() => {
        if(!time_id){ return }
        setSecondsRemaining({
            time_id,
            seconds: current_value
        });
        setStarted(true);
    },[time_id])

    useEffect(() => {
        if(!started){ return }
        if(seconds_remaining.seconds > 0){
            if(time_id != seconds_remaining.time_id){ return }
            setTimeout(() => {
                setSecondsRemaining({
                    time_id,
                    seconds: seconds_remaining.seconds - 1
                })
            }, increment_time);
        } else {
            if(time_id != seconds_remaining.time_id){ return }
            onTimesUp();
            setStarted(false);
        }
    },[seconds_remaining])


    if(seconds_remaining.seconds == 0){ return <></> }

    return (
        <ProgressBar
            max_value={max_value}
            val_label={`${increment_type} remaining`.toUpperCase()}
            current_value={seconds_remaining.seconds}
            background_color={Colors.views.header}
            max_label={max_label}
            round_decimal={0}
            hide_max_val
            fill_color={Colors.text.action}
        />
    )
}

export default ProgressTimer